"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
/**
 * Component that renders a basic message box with an error message and a configurable dismiss button.
 *
 * @param text to show as the title
 * @param errorMessage text to show in the message
 * @param backgroundColor the background color of the message box
 * @param dismissible whether the message box can be dismissed
 * @param fontColor the font color of the text inside the message box
 * @param onClose function to call when the close button is clicked
 * @param sx styles passed to the underlying root component
 *
 * @category Component
 */
var ErrorMessageBox = function (props) {
    var title = props.title, errorMessage = props.errorMessage, backgroundColor = props.backgroundColor, _a = props.dismissible, dismissible = _a === void 0 ? true : _a, fontColor = props.fontColor, _b = props.onClose, onClose = _b === void 0 ? function () { } : _b, sx = props.sx;
    return (react_1.default.createElement(Box_1.default, { sx: __spreadArray([
            {
                width: '100%',
                backgroundColor: backgroundColor || 'error.main',
                borderRadius: 4,
                p: 2,
                color: function (t) { return fontColor || t.palette.error.contrastText; },
                my: 2,
            }
        ], (Array.isArray(sx) ? sx : [sx]), true) },
        dismissible !== false && (react_1.default.createElement(Close_1.default, { "data-testid": 'error-message-box-close', sx: {
                '&:hover': {
                    cursor: 'pointer',
                },
                float: 'right',
            }, onClick: function () {
                onClose();
            } })),
        react_1.default.createElement(Box_1.default, null,
            react_1.default.createElement(Typography_1.default, null, title),
            react_1.default.createElement(Typography_1.default, { variant: "body2" }, errorMessage))));
};
exports.default = ErrorMessageBox;
